import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import { selectionBookingList } from '../selects'
import type {
  UnusedSkipTokenInfiniteOptions,
  UnusedSkipTokenOptions,
} from '@tanstack/react-query'
import type { PaginationWithStatusQueryParam } from '@/types/shared'
import type { HTTPError } from 'ky'
import type { HttpErrorResponse } from '@/types/error'
import { INITIAL_PER_PAGE } from '@/utils/constant'
import { myBookingService } from '@/services/my-booking'

export const getMyBookingsQueryOptions = (
  params?: Pick<PaginationWithStatusQueryParam, 'status'>,
  options?: Omit<
    UnusedSkipTokenInfiniteOptions<
      Awaited<ReturnType<typeof myBookingService.allBookings>>,
      HTTPError<HttpErrorResponse>,
      ReturnType<typeof selectionBookingList>,
      ReturnType<typeof queryKeys.myBooking.list>,
      number
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam' | 'select'
  >,
) =>
  infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: queryKeys.myBooking.list(params),
    queryFn: ({ pageParam }) =>
      myBookingService.allBookings({
        searchParams: {
          ...params,
          page: pageParam,
          per_page: INITIAL_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) => lastPage?.meta?.next_page,
    select: selectionBookingList,
    ...options,
  })

export const getMyBookingDetailQueryOptions = (
  id: string,
  options?: Omit<
    UnusedSkipTokenOptions<
      Awaited<ReturnType<typeof myBookingService.detail>>,
      HTTPError<HttpErrorResponse>,
      Awaited<ReturnType<typeof myBookingService.detail>>,
      ReturnType<typeof queryKeys.myBooking.detail>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.myBooking.detail(id),
    queryFn: () => myBookingService.detail({ id }),
    ...options,
  })
export const getTabListQueryOptions = (
  options?: Omit<
    UnusedSkipTokenOptions<
      Awaited<ReturnType<typeof myBookingService.tabList>>,
      HTTPError<HttpErrorResponse>,
      Awaited<ReturnType<typeof myBookingService.tabList>>,
      ReturnType<typeof queryKeys.myBooking.tabList>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.myBooking.tabList(),
    queryFn: () => myBookingService.tabList(),
    ...options,
  })
